export default __webpack_public_path__ + "2e5823f118bbd5fdb28d8141a0205d65.svg";